import CheckBoxField from 'components/StraightThroughHouseholdComp/CustomInputs/CheckBoxField/CheckBoxField';
import DateField from 'components/StraightThroughHouseholdComp/CustomInputs/DateField/DateField';
import NameField from 'components/StraightThroughHouseholdComp/CustomInputs/NameField/NameField';
import { RadioButtonField } from 'components/StraightThroughHouseholdComp/CustomInputs/RadioButtonField/RadioButtonField';
import SelectDropdown from 'components/StraightThroughHouseholdComp/CustomInputs/SelectDropdown/SelectDropdown';
import dlStatus from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/DLStatus';
import editDriverOptions from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/EditDriverOptions';
import { useDriverHHM } from 'components/StraightThroughHouseholdComp/HouseholdContext/DriverHHMContext';
import HelpfulDocumentsNJ from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsNJ/HelpfulDocumentsNJ';
import HelpfulDocumentsPA from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsPA/HelpfulDocumentsPA';
import { useState } from 'react';

const UpdateDriverForm = ({ context, changeClass }) => {
    const { driverHHM, driverHHMCallback, vehiclesNewAddressCallback } = useDriverHHM();
    const [dateOccurred, setDateOccurred] = useState("")

    const blNoLongerResides = driverHHM?.editType == "No longer resides in household.";
    const blNewAddress = driverHHM?.vehicleInfo?.takeVehiclesToNewAddress === "1";
    const blIsMichigan = context?.userData?.state === 'Michigan';
    const [requestedEffDate, setRequestedEffDate] = useState();
    return (
        <>
            <h5 className='text-primary text-center fw-bold my-3'>Update Driver</h5>

            <div style={{margin:"0px 0.5rem", padding: "0px 0.75rem"}}>

            <NameField
                name={`${driverHHM?.userInfo.firstName} ${driverHHM.userInfo.lastName}`}
                dob={`${driverHHM?.userInfo.dobMonth}/${driverHHM?.userInfo.dobDay}/${driverHHM?.userInfo.dobYear}`}
            />

            {/* Edit Type */}
            <SelectDropdown
                label={"What would you like to edit about this driver?*"}
                name={"editType"}
                value={driverHHM?.editType}
                dropdown={editDriverOptions}
                setCallback={driverHHMCallback}
            />

            {context?.addressChangeClass?.requestType !== "Address Change" && driverHHM?.editType &&
            <DateField
                label="Requested Effective Date*"
                dateSubmit={driverHHM?.requestedEffDate?driverHHM?.requestedEffDate:requestedEffDate}
                setDateSubmit={setRequestedEffDate}
                storeValue={driverHHMCallback}
                nameValue="requestedEffDate"
                infoKey="requestedEffDate"
            />
            }

            {blNoLongerResides &&
                <>
                    {/* Taking vehicles to new address */}
                    <RadioButtonField
                        question={"Is this driver taking any policy vehicles with them to their new address?*"}
                        uw={true}
                        infoKey='vehicleInfo'
                        name={'takeVehiclesToNewAddress'}
                        value={driverHHM?.vehicleInfo?.takeVehiclesToNewAddress || ""}
                        setCallback={driverHHMCallback}
                    />

                    {blNewAddress &&
                        <>
                            {/* Vehicles taken to new address */}
                            <CheckBoxField
                                label={"Which vehicles will be taken to the new address?*"}
                                list={changeClass?.vehicles?.vehiclesOnPolicy?.storedVehicles}
                                infoKey='vehicleInfo'
                                value={driverHHM?.vehicleInfo?.vehiclesAtNewAddress || []}
                                name={"vehiclesAtNewAddress"}
                                setCallback={vehiclesNewAddressCallback}
                            />
                        </>
                    }
                </>
            }

            {driverHHM?.editType == "No longer drives policy vehicles and still resides in household." &&
                <>
                    {/* Obtained own car insurance */}
                    <RadioButtonField
                        question={"Has this driver obtained their own car insurance?*"}
                        name={'ownInsurance'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.ownInsurance || ""}
                        setCallback={driverHHMCallback}
                    />
                </>
            }

            {driverHHM?.editType == "No longer has valid driver’s license." &&
                <>
                    {/* Edit Type */}
                    <SelectDropdown
                        label={"What is the current status of this driver's license?*"}
                        name={"licenseStatus"}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.licenseStatus}
                        dropdown={dlStatus(context?.userData?.state, false)}
                        setCallback={driverHHMCallback}
                    />

                    {/* Date of this occurrence */}
                    <DateField
                        label="When did this occur?*"
                        dateSubmit={driverHHM?.driverInfo?.dateOccurred ? driverHHM?.driverInfo?.dateOccurred : ""}
                        setDateSubmit={setDateOccurred}
                        storeValue={driverHHMCallback}
                        infoKey='driverInfo'
                        nameValue="dateOccurred"
                        noMinMax={true}
                    />
                </>
            }
            
            </div>
            {!blIsMichigan && (<>
            <hr />
            <div style={{margin:"0px 0.5rem", padding: "0px 0.75rem"}}>

            {/* Helpful Documents (New Jersey & Pennsylvania Only) */}
            {context?.userData?.state == 'New Jersey' ? (
                <div className='text-center'>
                    <HelpfulDocumentsNJ policyType={context?.userData?.policyType} />
                </div>
            ) : (
                <>
                    <HelpfulDocumentsPA center='center' />
                </>
            )}
            </div>
            </>)}
        </>
    )
}

export default UpdateDriverForm